/**
 * Dev helper: inspect logged-in user type, roles, permissions in the browser console.
 * Usage: open DevTools → Console → type showIdpAuth()
 */

export const buildAuthDebugSnapshot = (auth = {}) => {
  const user = auth.user || {};
  return {
    userType: auth.userType || null,
    tenantId: auth.tenantId || null,
    activeTenantId: auth.activeTenantId || null,
    activeTenantName: auth.activeTenantName || null,
    username: user.username || user.userName || null,
    userId: user.userId || user.id || null,
    roles: Array.isArray(auth.roles)
      ? auth.roles
      : Array.isArray(user.roles)
        ? user.roles
        : [],
    permissions: Array.isArray(auth.permissions)
      ? auth.permissions
      : Array.isArray(user.permissions)
        ? user.permissions
        : [],
  };
};

export const logAuthDebug = (auth = {}, label = "IDP Auth") => {
  if (typeof window === "undefined") return null;

  const snapshot = buildAuthDebugSnapshot(auth);
  window.__idpAuth = snapshot;

  // eslint-disable-next-line no-console
  console.log(`%c[${label}]`, "color:#0b5ed7;font-weight:700", {
    userType: snapshot.userType,
    username: snapshot.username,
    userId: snapshot.userId,
    tenantId: snapshot.tenantId,
    activeTenant: snapshot.activeTenantName || snapshot.activeTenantId,
    roles: snapshot.roles,
    permissions: snapshot.permissions,
  });
  // eslint-disable-next-line no-console
  console.log("Tip: run showIdpAuth() in the console anytime.");

  return snapshot;
};

export const clearAuthDebug = () => {
  if (typeof window === "undefined") return;
  window.__idpAuth = null;
};

export const installAuthDebugConsole = (getAuth) => {
  if (typeof window === "undefined") return;

  window.showIdpAuth = () => {
    const auth =
      typeof getAuth === "function"
        ? getAuth()
        : window.__idpAuth || {};
    return logAuthDebug(auth, "IDP Auth (manual)");
  };
};
